import { Component } from '@angular/core';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-download-not-ready-dialog',
  template: `
    <div class="dialog-container">
      <h2 mat-dialog-title>Download non disponibile</h2>
      <div mat-dialog-content>
        <p>Il download non è al momento disponibile. L’elaborazione del file è in corso.</p>
        <p>Ti invitiamo a ripetere la ricerca tra qualche istante per riprovare.</p>
      </div>
      <div mat-dialog-actions align="end">
        <button mat-button (click)="close()">Chiudi</button>
      </div>
    </div>
  `,
  styleUrls: ['download-not-ready-dialog.component.scss']
})
export class DownloadNotReadyDialogComponent {
  constructor(
    private dialogRef: MatLegacyDialogRef<DownloadNotReadyDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}